import { BaseModel } from "sjs-base-model";
import DatiUtenteRichiestaCedibilitaModel from "./DatiUtenteRichiestaCedibilitaModel";
import ResponseRichiestaCedibilitaModel from "./ResponseRichiestaCedibilitaModel";

export default class DettaglioRichiestaCedibilitaModel extends BaseModel {
    public readonly idTransferRequestDetail: number = 0;
    public readonly response: ResponseRichiestaCedibilitaModel = new ResponseRichiestaCedibilitaModel({});
    public readonly lastUserRequest: DatiUtenteRichiestaCedibilitaModel = new DatiUtenteRichiestaCedibilitaModel({});

    constructor(data: Partial<DettaglioRichiestaCedibilitaModel>) {
        super();

        this.update(data);
    }
}
